import React from 'react';

import PlaceholderTab from '~/components/Offers/Detail/OfferBuilder/shared/PlaceholderTab';

import { PACKAGE_OPTION_FIELDS } from './fields';

export default function PackageOptionsTab() {
  return <PlaceholderTab configuredFieldCount={PACKAGE_OPTION_FIELDS.length} title="Package Options" />;
}
